import InputField from './InputField';
import { InputFieldProps, InputFieldValueProps } from './types';

export type { InputFieldProps, InputFieldValueProps };
export default InputField;
